'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function exportFunction(content) {
    var entityData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return '<sub>' + content + '</sub>';
}
var SubScript = {
    constructor: function constructor() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var callbacks = {
            getEditorState: _utils.noop,
            setEditorState: _utils.noop
        };
        var toggleBlock = (0, _utils.getToggleEntityFunc)(callbacks);
        return {
            name: 'subscript',
            callbacks: callbacks,
            decorators: [{
                strategy: (0, _utils.findEntities)('subscript'),
                component: function component(props) {
                    return _react2["default"].createElement(
                        'sub',
                        null,
                        props.children
                    );
                }
            }],
            component: function component(props) {
                var _classnames;

                var editorState = callbacks.getEditorState();
                var contentState = editorState.getCurrentContent();
                var currentEntityKey = (0, _utils.getCurrentEntity)(editorState);
                var isSuperScript = currentEntityKey ? contentState.getEntity(currentEntityKey).getType() === 'subscript' : false;
                var classNames = (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, 'editor-icon', true), _defineProperty(_classnames, 'editor-icon-subscript', true), _defineProperty(_classnames, 'active', isSuperScript), _classnames));
                return _react2["default"].createElement('span', { onMouseDown: function onMouseDown() {
                        return toggleBlock('subscript', { "export": exportFunction }, isSuperScript);
                    }, className: classNames });
            }
        };
    },
    config: {}
};
exports["default"] = SubScript;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/SubScript/index.js
// module id = 124
// module chunks = 0 1 2